import Dexie from 'dexie';

const db = new Dexie('WorkbenchDB');

db.version(1).stores({
  connections: '++id', // name, shortName, bearerToken, betaApiKey, color, description
  tabs: '++id, connectionId', // title, timeOpened, timeClosed
  queries: '++id, tabId', // vbql, name
  categories: '++id, serverId, tabId',
});

db.open().catch((err) => {
  console.error(`Failed to open db: ${err.stack || err}`);
});


export default db;
